<template>
  <div class="c-list-date">{{ content() }}</div>
</template>

<script>
export default {
  name: 'CIS-Resource-PagedListing-Date',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    useDateIssued: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    content() {
      let timestamp = this.useDateIssued
        ? this.item.dateIssued?.value
        : this.item.publishedAt?.value;

      // Fall back to publishedAt if the dateIssued field is empty/invalid.
      const prefix = this.useDateIssued && timestamp ? 'Issued on' : 'Published on';
      if (!timestamp) {
        timestamp = this.item.publishedAt?.value;
      }

      // Wow, I can't believe it is this difficult to convert
      // the YYYYMMDDTHHmmssZ date format into a JS Date object!
      const date = new Date(
        new Date(
          timestamp.replace(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})(\w)?$/, '$1-$2-$3T$4:$5Z')
        )
      );

      if (isNaN(date)) {
        return '';
      }

      // use 2-digits for month and day, and use UTC so it isn't adjusted to local timezone, which can change the shown date
      const dateOptions = {
        weekday: undefined,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC'
      };

      // Use replace function for separator to be a dot instead of slash or dash
      const dateString = date?.toLocaleDateString(undefined, dateOptions)?.replace(/[^0-9]/g, '.');

      return `${prefix} ${dateString}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-list-date {
  @include font-styles('Arial Narrow', 1.4rem, 600, normal, normal, 0, $dark-blue);
  text-transform: uppercase;
}
</style>
